module.exports = __webpack_public_path__ + "static/media/ic-medicine-heart-beat.db7f5009.svg";